export default {
    ENTER: 13,
    ESCAPE: 27,
    SPACE: 32,
    UP: 38,
    DOWN: 40,
    TAB: 9,
    AWSUI_PREFIX: 'awsui:'
};
//# sourceMappingURL=constants.js.map